<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Crear Princio Activo"
  [style]="{ width: '400px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12">
            <label>Descripción</label>
            <input pInputText formControlName="description" type="text" />
            <div
              *ngIf="
                fg.get('description').invalid &&
                (fg.get('description').dirty || fg.get('description').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('description').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('description').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('description').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6"></div>
          <div class="field col-12 md:col-3">
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-3">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>
